import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import * as actionTypes from '../../constants/level/actionTypes'
import { levelAll, levelAllClear } from './actions'
import { defaultState, initialState } from './initialState'

export const LEVEL = actionTypes.GLOBAL_STATE

const levelSlice = createSlice({
  name: LEVEL,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(levelAll.pending, state => {
        state[actionTypes.LEVEL_ALL].loading = true
      })
      .addCase(levelAll.rejected, (state, action) => {
        state[actionTypes.LEVEL_ALL].loading = false
        state[actionTypes.LEVEL_ALL].error = action.payload as AxiosError
      })
      .addCase(levelAll.fulfilled, (state, action) => {
        state[actionTypes.LEVEL_ALL].loading = false
        state[actionTypes.LEVEL_ALL].error = null
        state[actionTypes.LEVEL_ALL].data = action.payload
      })

    builder.addCase(levelAllClear, state => {
      state[actionTypes.LEVEL_ALL] = defaultState()
    })
  },
})

export const { reducer: levelReducer } = levelSlice
